export default __webpack_public_path__ + "static/media/sideNavIcon.ec00dc5c.svg";